import { CartDropdown } from 'cart'
import Logo from 'components/Header/Logo'
import SearchInput from 'components/Search/SearchInput'
import UserDesktop from 'components/User/Desktop'
import { MainNavigation } from 'navigation'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import './style.scss'

export class Header extends PureComponent {
    render() {
        const { isCheckout, isMobile } = this.props
        if (isMobile) {
            return null
        } else {
            return (
                <header className={'header header--top'}>
                    <div className="left">
                        <MainNavigation />
                    </div>
                    <Logo />
                    <div className="right">
                        <SearchInput />
                        {!isCheckout && <CartDropdown />}
                        <UserDesktop />
                    </div>
                </header>
            )
        }
    }
}

Header.propTypes = {
    isCheckout: PropTypes.bool,
    isMobile: PropTypes.bool,
}

const mapStateToProps = ({ router, ui }) => {
    return {
        isCheckout: new RegExp(/^\/checkout/).test(router.location.pathname),
        isMobile: ui.isMobile,
    }
}

export default connect(mapStateToProps)(Header)
